"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PlayButton = _interopRequireDefault(require("../PlayButton/PlayButton"));
var _useBreakPoint = require("../../../common/useBreakPoint");
var _ExternalVideo = _interopRequireDefault(require("./ExternalVideo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.iframe-wrapper {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  position: fixed;\n  z-index: 10;\n  left: 0;\n  top: 0;\n  height: 100vh; }\n\n.iframe-wrapper .close {\n  position: absolute;\n  display: flex;\n  top: 10px;\n  right: 20px;\n  height: 56px;\n  width: 50px;\n  background-color: #000000;\n  padding: 5px;\n  justify-content: center;\n  align-items: center; }\n\n.iframe-wrapper.youtube .close {\n  top: 0px;\n  right: 0px;\n  width: 100%;\n  justify-content: flex-end; }\n\n.iframe-wrapper .close svg {\n  color: #fff;\n  cursor: pointer; }\n\n.iframe-wrapper iframe {\n  width: 100%;\n  height: 100%; }\n\n.video-container {\n  position: relative;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 2.389; }\n  .video-container .play-button-container {\n    position: absolute;\n    right: calc(50% - 27px);\n    bottom: calc(50% - 27px);\n    z-index: 1;\n    width: 56px;\n    height: 56px;\n    cursor: pointer; }\n  .video-container .play-button-container {\n    right: 52px;\n    bottom: 52px; }\n  .video-container img {\n    max-width: 100%;\n    height: 100%; }\n  @media (max-width: 66rem) {\n    .video-container {\n      aspect-ratio: 2.113; } }\n  @media (max-width: 42rem) {\n    .video-container {\n      aspect-ratio: 1.7977; }\n      .video-container .play-button-container {\n        position: absolute;\n        right: calc(50% - 27px);\n        bottom: calc(50% - 27px); } }\n";
  const fileName = "VideoSlide_VideoSlide";
  const element = document.querySelector("style[data-sass-component='VideoSlide_VideoSlide']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const VideoSlide = _ref => {
  let {
    item
  } = _ref;
  const {
    isDesktop,
    isTablet,
    isMobile
  } = (0, _useBreakPoint.useBreakPoint)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "video-container"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isDesktop && /*#__PURE__*/_react.default.createElement("img", {
    src: item.imagePlaceholder
  }), isTablet && /*#__PURE__*/_react.default.createElement("img", {
    src: item.imagePlaceholderTablet || item.imagePlaceholder
  }), isMobile && /*#__PURE__*/_react.default.createElement("img", {
    src: item.imagePlaceholderMobile || item.imagePlaceholder
  })), /*#__PURE__*/_react.default.createElement(_ExternalVideo.default, {
    itemSrc: item.src,
    start_second: item.start_second,
    stop_second: item.stop_second
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "play-button-container"
  }, /*#__PURE__*/_react.default.createElement(_PlayButton.default, null)))));
};
VideoSlide.propTypes = {
  item: _propTypes.default.object.isRequired
};
var _default = exports.default = VideoSlide;